import getExtensionFromPath from '@anm/helpers/getExtensionFromPath';

export const isAllowedExtension = (fileName: string, extensionsList: string) => {
  const extension = getExtensionFromPath(fileName) || '';

  return extensionsList.includes(extension.toLowerCase());
};

export default isAllowedExtension;
